import React, { useState, useEffect } from 'react';
import MotifMenu, { MotifMenuItem } from '@ey-xd/motif-react/Menu';
import {
  MotifButton, MotifFormField, MotifTooltip, MotifIcon, MotifCheckbox

} from "@ey-xd/motif-react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { infoIcon, deleteIcon, IconoirCheck, IconoirEye, downloadIcon, IconoirCheckIcon, IconoirFilterList } from '../../common/MotifIcons';
import MotifSearch from '@ey-xd/motif-react/Search';
import './partnerFileUpload.scss';
import BreadcrumbNavigation from './BreadcrumbNavigation';
import { MotifProgressLoader } from "@ey-xd/motif-react";
import FileViewerTest from './FileViewerTest';
import { getImagePath, getFileTypeName, getDateTimeFormat, getUploadedByFormat } from '../../common/utility/utility';
import useLogin from "../../common/redux/common/login/useLogin";
import FilterIcon from '../../common/images/filter-list.svg';
import SortUpDark from '../../common/images/sort-up-dark.svg';
import SortDownDark from '../../common/images/sort-down-dark.svg';
import SortUpLight from '../../common/images/sort-up-light.svg';
import SortDownLight from '../../common/images/sort-down-light.svg';
import { getAccount } from '../../common/services/commonService';
import SmallCircleLoader from './SmallCircleLoader';

import "./ViewFiles.scss";

export const ViewFiles = ({ show, onClose, fileUrl, items, fileName, isFileViewerOpen, setFileViewerOpen, setOpenDeleteDialog, rowData, isLoading, handleViewFilecontent, handleDownloadFileContent, handleRemoveFile, showToast, handleCloseToast, toastMessage, deleteTempFiles, baseURL, uploadedByList }) => {
  const [searchValue, setSearchValue] = useState("");
  const [activeTab, setActiveTab] = useState('clientEngagement'); // State for active tab
  const eyOwnedFilesCount = items?.filter(item => item.isEYOwned && !item.isClientData).length;

  const [openDialog, setOpenDialog] = React.useState(false);
  const [fileToDelete, setFileToDelete] = useState(null); // State to store the file to delete
  const [controlIdsToDelete, setControlIdsToDelete] = useState('');
  const [noOfDeleteIcon, setNoOfDeleteIcon] = useState('');
  // State to track which files are being deleted
  const [deletingFiles, setDeletingFiles] = useState(new Set());
  // State to track which folders are being deleted
  const [deletingFolders, setDeletingFolders] = useState(new Set());
  // State to track the folder being deleted
  const [folderToDelete, setFolderToDelete] = useState(null);
  // const [isFileViewerOpen, setFileViewerOpen] = useState(false);
  const [selectedControlIds, setSelectedControlIds] = useState([]);
  const { loginDetail } = useLogin();
  const userName = getAccount()?.username;
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedUploader, setSelectedUploader] = useState(null);
  const [onClickAtoZ, setOnClickAtoZ] = useState(false);
  const [onClickZtoA, setOnClickZtoA] = useState(false);
  const [onClickNewest, setOnClickNewest] = useState(false);
  const [onClickOldest, setOnClickOldest] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const clientEngagementFilesCount = (filteredData.length > 0 ? filteredData : items).filter(item => item.isEYOwned && item.isClientData).length;

  //const isEngagementAdminUser = loginDetail?.data?.isEngagementAdmin == undefined ? false : loginDetail?.data?.isEngagementAdmin;
  const userProfileDetails = JSON.parse(sessionStorage.getItem("profileDetails"));
  const isEngagementAdminUser = userProfileDetails?.isEngagementAdmin || false;

  const isDataUploader = (rowData?.datA_UPLOADERS_EMAIL?.toLowerCase().includes(userName?.toLowerCase())
    ||
    rowData?.engagementPartners?.toLowerCase() === userName?.toLowerCase())


  // const [isLoading, setIsLoading] = React.useState(true);
  // const handleViewFile = (file) => {
  //   handleViewFilecontent(file);
  //   setFileViewerOpen(true); // Open the file viewer modal
  // };

  const handleSelectAll = (e) => {
    const isSearching = (searchValue || "").trim().length > 0;
    const isUploaderFiltered = Array.isArray(selectedUploader) && selectedUploader.length > 0;

    if (e.target.checked) {
      if (isSearching || isUploaderFiltered) {
        // When searching or uploader filter is applied: select only the filtered (searched &/or uploader) non-anonymized files
        const filtered = filteredData
          .filter(f => !f.isAnonymized)
          .filter(f => !isUploaderFiltered || selectedUploader.includes(f.uploadedBy));
        const controlIds = filtered.map(f => f.controlId);

        setSelectedControlIds(prev => Array.from(new Set([...(prev || []), ...controlIds])));
      } else {
        // Default: select all non-anonymized files across items + subfolders
        const allControlIds = [
          ...items.filter(file => !file.isAnonymized).map(file => file.controlId),
          ...Object.entries(currentFolderContents?.subFolders || {}).flatMap(([_, content]) =>
            getAllFilesRecursively(content).filter(file => !file.isAnonymized).map(file => file.controlId)
          )
        ];

        const uniqueControlIds = Array.from(new Set(allControlIds));
        setSelectedControlIds(uniqueControlIds);
      }
    } else {
      if (isSearching || isUploaderFiltered) {
        // When searching or uploader filter is applied: deselect only the currently filtered files, keep other selections
        const filtered = filteredData
          .filter(f => !f.isAnonymized)
          .filter(f => !isUploaderFiltered || selectedUploader.includes(f.uploadedBy));
        const searchControlIdSet = new Set(filtered.map(f => f.controlId));
        setSelectedControlIds(prev => (prev || []).filter(id => !searchControlIdSet.has(id)));
      } else {
        // Default: clear all selections
        setSelectedControlIds([]);
      }
    }
  };

  useEffect(() => {
    if (rowData?.clientData) {
      setActiveTab('clientEngagement');

    } else {
      setActiveTab('eyOwned');
    }
  }, [rowData?.eyOwnedData, rowData?.clientData]);


  const [currentPath, setCurrentPath] = useState([]);
  useEffect(() => {
    if (show) {
      setCurrentPath([]);
      setSearchValue("");
    }
  }, [show]); // Runs only when `show` changes

  // Clear deletion states when files are removed successfully
  useEffect(() => {
    if (!isLoading) {
      setDeletingFiles(new Set());
      setDeletingFolders(new Set());
    }
  }, [isLoading]);
  useEffect(() => {
    setFilteredData(items?.filter((item) => {
      // Check if the file name includes the search value
      const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
      // Determine which files to show based on the active tab and the isEYOwned flag
      const shouldShowFile = activeTab === 'eyOwned' ? item.isEYOwned && !item.isClientData : item.isEYOwned && item.isClientData;
      // Return true if both conditions are met
      //const isNotZip = item?.fileName && !item.fileName.toLowerCase().endsWith('.zip');
      return matchesSearch && shouldShowFile; //&& isNotZip;
    }));
  }, [activeTab, items, searchValue])

  function buildFileStructure(files) {

    let structure = { files: {}, subFolders: {} };

    files.forEach(file => {
      if (!file.path) {
        const fileIdentifier = file.fileName + file.controlId;
        structure.files[fileIdentifier] = file;
        return;
      }
      const normalizedPath = file.path.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
      const pathParts = normalizedPath.split("/");
      const fileName = pathParts.pop(); // Extract file name
      const fileControlID = file.controlId;
      const fileIdentifier = fileName + fileControlID;
      let currentLevel = structure;
      pathParts.forEach(folder => {
        if (!currentLevel.subFolders[folder]) {
          currentLevel.subFolders[folder] = { files: {}, subFolders: {} };
        }
        currentLevel = currentLevel.subFolders[folder];
      });

      currentLevel.files[fileIdentifier] = { ...file };
    });
    return structure;
  }

  const fileStructure = buildFileStructure(filteredData);
  const getCurrentFolderContents = () => {
    let currentLevel = fileStructure; // Start from root
    for (const part of currentPath) {
      if (!currentLevel.subFolders[part]) {
        return { subFolders: {}, files: {} }; // Return empty structure if path is invalid
      }
      currentLevel = currentLevel.subFolders[part]; // Navigate deeper
    }
    return currentLevel;
  };
  const navigateToFolder = (folderName) => {
    const newPath = [...currentPath, folderName];
    setCurrentPath(newPath);
  };

  const goBack = (index) => {
    if (index === -1) {
      setCurrentPath([]);
    } else {
      setCurrentPath(currentPath.slice(0, index + 1));
    }
  };

  const getCurrentPath = () => {
    return currentPath.join('/');
  };

  const countFilesRecursively = (folder) => {
    return Object.keys(folder.files || {}).length +
      Object.values(folder.subFolders || {}).reduce(
        (count, subFolder) => count + countFilesRecursively(subFolder), 0
      );
  };
  const currentFolderContents = getCurrentFolderContents();

  const onFilterTextBoxChanged = (value) => {
    setSearchValue(value);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setFileToDelete(null); // Reset the file to delete
    setFolderToDelete(null); // Reset the folder to delete
    // setSelectedControlIds(null);
    setControlIdsToDelete(null);

  };
  const getAllFilesRecursively = (folder) => {
    let files = Object.values(folder.files || {});
    for (const sub of Object.values(folder.subFolders || {})) {
      files = files.concat(getAllFilesRecursively(sub));
    }
    return files;
  }


  const handleDialogConfirm = () => {
    if (fileToDelete) {
      // Add file to deleting set
      setDeletingFiles(prev => new Set([...prev, fileToDelete.controlId]));

      // Check if file is inside a folder and add folder to deleting set
      const folderPath = fileToDelete.path?.split('/').slice(0, -1).join('/');
      if (folderPath) {
        setDeletingFolders(prev => new Set([...prev, folderPath]));
      }

      handleRemoveFile({
        controlId: String(fileToDelete.controlId),
        controlIdArray: fileToDelete.controlId,
        area: rowData?.area,
        noOfSelectedFiles: 1,
        noOfDeleteIcon: fileToDelete.noOfDeleteIcon,
        noOfUploadedFiles: rowData?.noOfUploadedFiles,
        engagementTrackingStatus: rowData?.engagementTrackingStatus,
        engagementId: rowData?.engagementId,
        isPending: false
      });
    }
    else if (selectedControlIds.length > 0) {
      // Add all selected files to deleting set
      setDeletingFiles(prev => new Set([...prev, ...selectedControlIds]));

      // Add folder to deleting set for folder-level deletion
      if (folderToDelete) {
        setDeletingFolders(prev => new Set([...prev, folderToDelete]));
      }

      const controlIdsString = selectedControlIds.join(',');
      handleRemoveFile({
        controlId: controlIdsString,
        controlIdArray: selectedControlIds[0],
        area: rowData?.area,
        noOfDeleteIcon: noOfDeleteIcon,
        noOfSelectedFiles: selectedControlIds.length,
        noOfUploadedFiles: rowData?.noOfUploadedFiles,
        engagementTrackingStatus: rowData?.engagementTrackingStatus,
        engagementId: rowData?.engagementId,
        isPending: false
      });
    }

    setSelectedControlIds([]); // Clear selected control IDs after deletion
    setSelectedUploader([]); // Clear selected uploaders after deletion
    handleDialogClose();
    setFileViewerOpen(false);

  };
  const handleFileCheckboxChange = (file) => {
    const newSelected = selectedControlIds.includes(file.controlId)
      ? selectedControlIds.filter(id => id !== file.controlId)
      : [...selectedControlIds, file.controlId];
    setSelectedControlIds(newSelected);
  };

  // Function to handle folder checkbox changes
  const handleFolderCheckboxChange = (folderName, filesInFolder) => {
    const isChecked = filesInFolder.every(file => selectedControlIds.includes(file.controlId));
    if (isChecked) {
      const controlIdsToRemove = filesInFolder.map(file => file.controlId);
      setSelectedControlIds(prev => prev.filter(id => !controlIdsToRemove.includes(id))); // Remove control IDs
    } else {
      const controlIdsToAdd = filesInFolder.map(file => file.controlId);
      setSelectedControlIds(prev => [...new Set([...prev, ...controlIdsToAdd])]); // Add unique control IDs
    }
  };


  const FileTile = ({ file, onViewFile }) => {

    const fileTypeName = getFileTypeName(file.fileName);
    const imagePath = getImagePath(file.fileName);
    const rawname = String.raw`${file.fileName}`;
    const filename = rawname.split("\\").pop();
    const isSearching = (searchValue || "").trim().length > 0;
    const getHighlightedNodes = (text, highlight) => {
      if (!highlight) return <span className="file-name-text">{text}</span>;
      const escaped = highlight.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      const re = new RegExp(escaped, 'ig');
      const nodes = [];
      let lastIndex = 0;
      let m;
      while ((m = re.exec(text)) !== null) {
        const start = m.index;
        const end = re.lastIndex;
        if (start > lastIndex) nodes.push(text.slice(lastIndex, start));
        nodes.push(
          <span key={start} className="search-highlight" style={{ backgroundColor: 'yellow' }}>
            {text.slice(start, end)}
          </span>
        );
        lastIndex = end;
      }
      if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
      return <span className="file-name-text">{nodes}</span>;
    };

    const extension = file.fileName.split('.').pop().toLowerCase();

    return (
      <div className="file-item file-item-view">

        <div className="file-icon">
          {(!isEngagementAdminUser || isDataUploader) && !file.isAnonymized && (
            <MotifCheckbox
              id={file.controlId}
              value={file.controlId}
              checked={selectedControlIds.includes(file.controlId)}
              onChange={(e) => {
                const newSelected = e.target.checked
                  ? [...selectedControlIds, file.controlId]
                  : selectedControlIds.filter(id => id !== file.controlId);
                setSelectedControlIds(newSelected);
              }}
              className='file-checkbox'
            />
          )}
          {(!isEngagementAdminUser || isDataUploader) && file.isAnonymized && (
            <MotifCheckbox
              id={file.controlId}
              value={file.controlId}
              checked={selectedControlIds.includes(file.controlId)}
              disabled={true}
              onChange={(e) => {
                const newSelected = e.target.checked
                  ? [...selectedControlIds, file.controlId]
                  : selectedControlIds.filter(id => id !== file.controlId);
                setSelectedControlIds(newSelected);
              }}
              className='file-checkbox'
            />
          )}
          <img src={imagePath} alt="File icon" />
        </div>
        <div className="file-details file-details-view">
          <div className="file-name file-name-view" title={filename}>
            <div style={{ display: 'flex' }}>
              {getHighlightedNodes(filename, searchValue)}
              <MotifTooltip
                allowClick
                allowHover
                closeButtonProps={{}}

                flip


                id="tooltip"

                placement="auto"

                trigger={<MotifIcon src={infoIcon} className='tooltip-icon-margin' />}

                variant="alt"
                className="file-tooltip"
              >
                Uploaded by: {file.uploadedBy}<br />
                Created Date:  {file?.dateCreated ? getDateTimeFormat(file.dateCreated) : ""}
              </MotifTooltip>
              {file?.isAnonymized && (
                <div
                  className="submitted-container "

                >  <MotifIcon src={IconoirCheck} />
                  Submitted
                </div>
              )}
            </div>
            <div className="file-type file-type-view"> <span className='spn-file-type-label'>Type:</span> {fileTypeName} File</div>
          </div>


          <div className="file-meta-row">
            <span className="file-meta-value">
              {file.dateCreated
                ? getDateTimeFormat(file.dateCreated) + ","
                : ""}
            </span>
            <span className="file-meta-label">Uploaded by:</span>
            <span className="file-meta-value">{getUploadedByFormat(file.uploadedBy)}</span>
          </div>
          {isSearching && <div className="file-path" title={file.path}>Path : {file.path} File</div>}
         
        </div>
         {(!isEngagementAdminUser || isDataUploader) ? (<div className='ft-file-actions ft-file-actions-view'>
            {!file?.isAnonymized && (['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'xlsb', 'ppt', 'pptx', 'pdf'].includes(extension)) && !deletingFiles.has(file.controlId) && (
              <button
                className="ft-file-eyeIcon"
                // onClick={() => onViewFile({ controlId: file.controlId })}
                onClick={() => {
                  setFileToDelete(file);
                  setFileViewerOpen(true);
                  handleViewFilecontent({
                    controlId: file?.controlId,
                    fileName: file?.fileName

                  });
                }}
              //  onClick={() => onViewFile({ controlId: file.controlId })} // Use the passed function
              >
                {!isEngagementAdminUser || isDataUploader ? <MotifIcon src={IconoirEye} /> : null}
                {/* <MotifIcon src={IconoirEye} /> */}
              </button>
            )}
            {!file?.isAnonymized && !deletingFiles.has(file.controlId) && (
              <button
                className="ft-file-download"
                onClick={() => {
                  handleDownloadFileContent({
                    controlId: file?.controlId,
                    fileName: file?.fileName

                  });
                }
                }
              >
                {!isEngagementAdminUser || isDataUploader ? <MotifIcon src={downloadIcon} /> : null}
                {/* <MotifIcon src={downloadIcon} /> */}
              </button>
            )}
            {!file?.isAnonymized && (
              <button
                className="ft-file-remove-viewFiles"
                disabled={deletingFiles.has(file.controlId)}
                onClick={() => {
                  setFileToDelete(file); // Set the file to delete
                  setOpenDialog(true); // Open the dialog
                }}
              >
                {deletingFiles.has(file.controlId) ? (
                  <SmallCircleLoader color="#ff0000" />
                ) : (
                  !isEngagementAdminUser || isDataUploader ? <MotifIcon src={deleteIcon} /> : null
                )}
              </button>
            )}
          </div>) : null}
      </div>
    );
  };

  const handleToggleSelectAllUploaders = () => {
    const allUploaders = Array.from(new Set(filteredData.map(file => file.uploadedBy)));
    if (
      Array.isArray(selectedUploader) &&
      selectedUploader.length === allUploaders.length
    ) {
      // Deselect all
      setSelectedUploader([]);
      setFilteredData(
        items.filter((item) => {
          const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
          const shouldShowFile = activeTab === 'eyOwned' ? item.isEYOwned && !item.isClientData : item.isEYOwned && item.isClientData;
          return matchesSearch && shouldShowFile;
        })
      );
      setSelectedControlIds([]);
    } else {
      // Select all
      setSelectedUploader(allUploaders);
      // uploadedByList(allUploaders);
      setFilteredData(
        items.filter((item) => {
          const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
          const shouldShowFile = activeTab === 'eyOwned' ? item.isEYOwned && !item.isClientData : item.isEYOwned && item.isClientData;
          return matchesSearch && shouldShowFile && allUploaders.includes(item.uploadedBy);
        })
      );
    }
  };
  const handleViewPageClose = () => {
    setSelectedControlIds([]);
    onClose();
    setSelectedUploader(null);
    setIsFilterOpen(false);
    setOnClickAtoZ(false);
    setOnClickZtoA(false);
    setOnClickNewest(false);
    setOnClickOldest(false);
  };
  return (

    <>
      <MotifMenu show={show} onClose={() => handleViewPageClose()} className="motif-menu-container motif-menu-container-view-files" size="large">
        <div className="motif-menu-view-files-container">
          <MotifMenuItem className="motif-menu-view-files" disabled>
            <strong>View Files </strong>
            <div className="engagement-id engagement-id-font" >
              {rowData?.engagementId} | {rowData?.engagementName}
            </div>
          </MotifMenuItem>
        </div>

        <div className="tab-buttons">
          {rowData?.clientData && (
            <MotifButton
              className={activeTab === 'clientEngagement' ? 'selected' : ''} // Add selected class
              variant={activeTab === 'clientEngagement' ? 'primary' : 'secondary'}
              onClick={() => { setActiveTab('clientEngagement'); setCurrentPath([]); }}
              style={{ textAlign: 'left' }}
            >
              Client Data & EY Owned Data<span className="no-of-files">{clientEngagementFilesCount}</span>
            </MotifButton>
          )}

          {!rowData?.clientData && (
            <MotifButton
              className={activeTab === 'eyOwned' ? 'selected' : ''} // Add selected class
              variant={activeTab === 'eyOwned' ? 'primary' : 'secondary'}
              onClick={() => { setActiveTab('eyOwned'); setCurrentPath([]); }}
            >
              EY Owned Data<span className="no-of-files">{eyOwnedFilesCount}</span>
            </MotifButton>
          )}
        </div>

        <div className="files-search-container">
          <MotifFormField>
            <MotifSearch
              aria-label='Search'
              onChange={(e) => onFilterTextBoxChanged(e.target?.value)}
              placeholder='Search...'
              value={searchValue}
            />
          </MotifFormField>
        </div>


        {/* Render the file list below both tabs */}
        {isLoading && !isFileViewerOpen ? (
          <MotifProgressLoader show variant="default" />
        ) : (<div className="file-list-container file-list-container-spacing">
          {filteredData.length > 0 && (<div className="file-list-breadcrumb">
            <BreadcrumbNavigation currentPath={currentPath} goBack={goBack} isClientEngagement={activeTab === 'clientEngagement'} />
          </div>)
          }
          <div className="view-files-list-body">
            {/* Render folders first */}

            <div className="select-all-container select-all-container-content" >
              {(!isEngagementAdminUser || isDataUploader) && filteredData.length > 0 && (<> <div className='global-actions'>

                <MotifButton
                  style={{ gap: "6px", height: 27 }}
                  variant="secondary"
                  onClick={() => {
                    if (selectedControlIds.length > 0) {
                      setOpenDialog(true); // Open the dialog only if there are selected control IDs
                    }
                  }}
                  disabled={selectedControlIds.length === 0}
                >
                  <MotifIcon
                    src={deleteIcon}
                    style={{ width: "17px", height: "17px", gap: "16px" }}
                  />
                  Delete all
                </MotifButton>
                <MotifButton
                  style={{ gap: "6px", height: 27 }}
                  variant="secondary"
                  onClick={() => setIsFilterOpen(!isFilterOpen)}

                >
                  <MotifIcon
                    src={IconoirFilterList}
                    style={{ width: "17px", height: "17px", gap: "16px" }}
                  />
                  {/* <img className='file-filter-icon' src={FilterIcon} style={{ height: 13, verticalAlign: 'middle' }} /> */}
                  Filter
                </MotifButton>
              </div>
              </>)}
              <div className='checkbox-align'>
                <div className="left-section">
                  {(!isEngagementAdminUser || isDataUploader) && <MotifCheckbox
                    id="select-all"
                    className="file-checkbox"
                    onChange={handleSelectAll}
                    disabled={items.filter(file => !file.isAnonymized).length === 0}
                    checked={
                      (() => {
                        const isSearching = (searchValue || "").trim().length > 0;
                        const isUploaderFiltered = Array.isArray(selectedUploader) && selectedUploader.length > 0;

                        if (isSearching || isUploaderFiltered) {
                          // Only consider filteredData (search or uploader filter)
                          const visible = filteredData.filter(f => !f.isAnonymized);
                          return visible.length > 0 && visible.every(f => selectedControlIds.includes(f.controlId));
                        }

                        // Default: all non-anonymized files in items + subfolders
                        const nonAnonymizedItems = items.filter(file => !file.isAnonymized);
                        const subfolderControlIds = Object.entries(currentFolderContents?.subFolders || {})
                          .flatMap(([_, content]) =>
                            getAllFilesRecursively(content)
                              .filter(file => !file.isAnonymized)
                              .map(file => file.controlId)
                          );

                        const allControlIds = [
                          ...nonAnonymizedItems.map(file => file.controlId),
                          ...subfolderControlIds
                        ];

                        return allControlIds.length > 0 && allControlIds.every(controlId => selectedControlIds.includes(controlId));
                      })()

                    }
                  />
                  }



                  <span className="selectAll-text">Files Name</span></div>
                <div className="selectAll-text">Actions</div>
              </div>
            </div>



            {isFilterOpen && (
              <MotifMenu className="file-filter-menu" show={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
                <div className='file-filter-menu__title-one'>Filter</div>
                <div className='file-filter-menu__subtitle-one'>Uploaded by</div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                  <MotifCheckbox
                    id={`uploader-select-all`}
                    label={""}
                    checked={
                      Array.isArray(selectedUploader)
                        ? selectedUploader.length === Array.from(new Set(items
                          .filter((item) => {
                            const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
                            const shouldShowFile = activeTab === 'eyOwned'
                              ? item.isEYOwned && !item.isClientData
                              : item.isEYOwned && item.isClientData;
                            return matchesSearch && shouldShowFile;
                          })
                          .map(file => file.uploadedBy)
                        )).length
                        : false
                    }
                    onChange={() => { handleToggleSelectAllUploaders(selectedUploader) }}
                    style={{ marginRight: 8 }}
                  />
                  <span style={{ fontSize: 14 }}>Select All</span>
                </div>
                <hr className='file-filter-menu__divider-one' />
                {Array.from(new Set(items
                  .filter((item) => {
                    const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
                    const shouldShowFile = activeTab === 'eyOwned'
                      ? item.isEYOwned && !item.isClientData
                      : item.isEYOwned && item.isClientData;
                    return matchesSearch && shouldShowFile;
                  })
                  .map(file => file.uploadedBy)
                )).map((uploader) => (
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }} key={uploader}>
                    <MotifCheckbox
                      id={`uploader-${uploader}`}
                      label={""}
                      checked={Array.isArray(selectedUploader) ? selectedUploader.includes(uploader) : false}
                      onChange={() => {
                        let updatedUploader;
                        if (Array.isArray(selectedUploader)) {
                          if (selectedUploader.includes(uploader)) {
                            updatedUploader = selectedUploader.filter(u => u !== uploader);
                          } else {
                            updatedUploader = [...selectedUploader, uploader];
                          }
                        } else {
                          updatedUploader = [uploader];
                        }
                        setSelectedUploader(updatedUploader);

                        // Always filter from items, not filteredData
                        if (updatedUploader.length === 0) {
                          setFilteredData(items.filter((item) => {
                            const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
                            const shouldShowFile = activeTab === 'eyOwned'
                              ? item.isEYOwned && !item.isClientData
                              : item.isEYOwned && item.isClientData;
                            return matchesSearch && shouldShowFile;
                          }));
                          setSelectedControlIds([]);
                        } else {
                          const filtered = items.filter((item) => {
                            const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
                            const shouldShowFile = activeTab === 'eyOwned'
                              ? item.isEYOwned && !item.isClientData
                              : item.isEYOwned && item.isClientData;
                            return matchesSearch && shouldShowFile && updatedUploader.includes(item.uploadedBy);
                          });
                          setFilteredData(filtered);
                          // uploadedByList(updatedUploader);
                        }
                      }}
                      style={{ marginRight: 8 }}
                    />
                    <span style={{ fontSize: 14 }}>{getUploadedByFormat(uploader)}</span>
                  </div>
                ))}
                <hr className='file-filter-menu__divider-two' />
                <div className='file-filter-menu__title-two'>Sort by</div>
                <div className='file-filter-menu__subtitle-two'>Date & Time</div>
                <div
                  onClick={() => {
                    // Sort filteredData by dateCreated (newest first)
                    const sorted = [...filteredData].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));
                    setFilteredData(sorted);
                    setOnClickNewest(true);
                    setOnClickOldest(false);
                    setOnClickAtoZ(false);
                    setOnClickZtoA(false);
                    // If you use filteredData directly, update its source or add a sort state
                  }}
                  className='file-filter-menu__sort-option-container'
                  style={{ background: onClickNewest ? '#E6E6E9' : '' }}
                >
                  <img
                    src={onClickNewest ? SortUpDark : SortUpLight}
                    className={onClickNewest ? '' : 'file-filter-menu__sortup-icon-light'}
                    style={{ marginRight: 6, verticalAlign: 'middle' }}
                  />
                  <span className='file-filter-menu__sort-option'>Newest on top</span>
                  {onClickNewest && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                </div>
                <div
                  //checked={true} // Replace with your sort state logic
                  onClick={() => {
                    // Sort filteredData by dateCreated (oldest first)
                    const sorted = [...filteredData].sort((a, b) => new Date(a.dateCreated) - new Date(b.dateCreated));
                    setFilteredData(sorted);
                    // If you use filteredData directly, update its source or add a sort state
                    setOnClickOldest(true);
                    setOnClickNewest(false);
                    setOnClickAtoZ(false);
                    setOnClickZtoA(false);
                  }}
                  className='file-filter-menu__sort-option-container'
                  style={{ background: onClickOldest ? '#E6E6E9' : '' }}
                >
                  <img
                    src={onClickOldest ? SortDownDark : SortDownLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                  <span className='file-filter-menu__sort-option'>Oldest on top</span>
                  {onClickOldest && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                </div>
                <div className='file-filter-menu__subtitle-three'>Alphanumeric</div>
                <div
                  onClick={() => {
                    // Sort filteredData A to Z
                    const sorted = [...filteredData].sort((a, b) => a.fileName.localeCompare(b.fileName));
                    setFilteredData(sorted);
                    // If you use filteredData directly, update its source or add a sort state
                    setOnClickAtoZ(true);
                    setOnClickZtoA(false);
                    setOnClickOldest(false);
                    setOnClickNewest(false);
                  }}
                  className='file-filter-menu__sort-option-container'
                  style={{ background: onClickAtoZ ? '#E6E6E9' : '' }}
                >
                  <img
                    src={onClickAtoZ ? SortUpDark : SortUpLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                  <span className='file-filter-menu__sort-option'>A to Z</span>
                  {onClickAtoZ && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                </div>
                <div
                  onClick={() => {
                    // Sort filteredData Z to A
                    const sorted = [...filteredData].sort((a, b) => b.fileName.localeCompare(a.fileName));
                    setFilteredData(sorted);
                    // If you use filteredData directly, update its source or add a sort state
                    setOnClickZtoA(true);
                    setOnClickAtoZ(false);
                    setOnClickOldest(false);
                    setOnClickNewest(false);
                  }}
                  className='file-filter-menu__sort-option-container'
                  style={{ background: onClickZtoA ? '#E6E6E9' : '' }}
                ><img
                    src={onClickZtoA ? SortDownDark : SortDownLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                  <span className='file-filter-menu__sort-option'>Z to A</span>
                  {onClickZtoA && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                </div>
              </MotifMenu>)}
            {filteredData.length > 0 ? (
              <div style={{ flex: '1 1 auto', minHeight: 0, overflowY: 'scroll', overflowX: 'hidden' }}>
                {(() => {
                  const isSearching = (searchValue || "").trim().length > 0;

                  // When searching, show matching files flattened (inside folders too)
                  if (isSearching) {
                    return (
                      <>
                        {filteredData.map((file) => (
                          <FileTile
                            key={`${file.fileName}-${file.controlId}`}
                            file={file}
                            onCheckboxChange={() => handleFileCheckboxChange(file)}
                          />
                        ))}
                      </>
                    );
                  }

                  // Default (not searching): show folders then files in current folder
                  // Determine folder order based on sort state
                  let folderEntries = Object.entries(currentFolderContents?.subFolders || {});
                  if (onClickAtoZ) {
                    folderEntries = folderEntries.sort(([a], [b]) => a.localeCompare(b));
                  } else if (onClickZtoA) {
                    folderEntries = folderEntries.sort(([a], [b]) => b.localeCompare(a));
                  }
                  return (
                    <>
                      {folderEntries.map(([name, content]) => {
                        const fileCount = countFilesRecursively(content);
                        const isZip = name.endsWith(".zip");
                        const allFiles = getAllFilesRecursively(content);
                        const hasAnonymizedFile = allFiles.some((file) => file.isAnonymized);
                        const controlIds = allFiles.map((file) => file.controlId);
                        const noOfDeleteIconArray = allFiles.map((file) => file.noOfDeleteIcon);
                        const noOfDeleteIcon = noOfDeleteIconArray.length > 0 ? noOfDeleteIconArray[0] : 0;
                        const filesInFolder = getAllFilesRecursively(content);
                        const folderPath = currentPath.length > 0 ? `${currentPath.join('/')}/${name}` : name;

                        // Find the most recent uploadedBy in this folder
                        let uploadedBy = "";
                        let latestDate = null;
                        filesInFolder.forEach(file => {
                          if (file.dateCreated) {
                            const fileDate = new Date(file.dateCreated);
                            if (!latestDate || fileDate > latestDate) {
                              latestDate = fileDate;
                              uploadedBy = file.uploadedBy;
                            }
                          }
                        });

                        return (
                          <div className="file-item file-item-view" key={name}>
                            <div className="file-icon">
                              {(!isEngagementAdminUser || isDataUploader) && !hasAnonymizedFile && (
                                <MotifCheckbox
                                  id={name}
                                  value={name}
                                  checked={filesInFolder.every((file) => selectedControlIds.includes(file.controlId))}
                                  onChange={() => handleFolderCheckboxChange(name, filesInFolder)}
                                  className="file-checkbox"
                                />
                              )}
                              {(!isEngagementAdminUser || isDataUploader) && hasAnonymizedFile && (
                                <MotifCheckbox
                                  id={name}
                                  value={name}
                                  checked={filesInFolder.every((file) => selectedControlIds.includes(file.controlId))}
                                  disabled={true}
                                  onChange={() => handleFolderCheckboxChange(name, filesInFolder)}
                                  className="file-checkbox"
                                />
                              )}
                              <img
                                src={isZip ? require("../../common/images/zip.png") : require("../../common/images/folder.png")}
                                alt={isZip ? "ZIP file icon" : "Folder icon"}
                              />
                            </div>

                            <div className="file-details file-details-view">
                              {/* <div className="ft-file-name-container"> */}
                              <div className="file-name cursor-pointer file-name-view" >
                                <div title={name} style={{ display: 'flex' }}>
                                  <span className="ft-file-name-text cursor-pointer" onClick={() => navigateToFolder(name)}>
                                    {name}
                                  </span>
                                  {hasAnonymizedFile && (
                                    <div className="submitted-container">
                                      <MotifIcon src={IconoirCheck} />
                                      Submitted
                                    </div>
                                  )}
                                </div>
                                <div className="file-type file-type-view"><span className='spn-file-type-label'>Type:</span> {isZip ? "ZIP File" : "Folder"}, {fileCount} Files</div>

                              </div>

                              {/* </div> */}
                              <div className="file-meta-row">
                                <span className="file-meta-value">
                                  {latestDate
                                    ? getDateTimeFormat(latestDate) + ","
                                    : ""}
                                </span>
                                <span className="file-meta-label">
                                  Uploaded by:
                                </span>
                                <span className="file-meta-value">
                                  {getUploadedByFormat(uploadedBy)}
                                </span>
                              </div>
                             
                            </div>

{(!isEngagementAdminUser || isDataUploader) ? (<div className='ft-file-actions'>
                                {!hasAnonymizedFile && (
                                  <button
                                    className="ft-file-remove-viewFiles"
                                    disabled={deletingFolders.has(folderPath) || controlIds.some(id => deletingFiles.has(id))}
                                    onClick={() => {
                                      setSelectedControlIds(controlIds);
                                      setNoOfDeleteIcon(noOfDeleteIcon);
                                      setFolderToDelete(folderPath);
                                      setOpenDialog(true);
                                    }}
                                  >
                                    {deletingFolders.has(folderPath) || controlIds.some(id => deletingFiles.has(id)) ? (
                                      <SmallCircleLoader color="#ff0000" />
                                    ) : (
                                      !isEngagementAdminUser || isDataUploader ? <MotifIcon src={deleteIcon} /> : null
                                    )}
                                  </button>
                                )}
                              </div>) : null }
                          </div>
                        );
                      })}

                      {/* Render files in current folder */}
                      {Object.entries(currentFolderContents?.files || {}).map(([name, file]) => (
                        <FileTile key={name} file={file} onCheckboxChange={() => handleFileCheckboxChange(file)} />
                      ))}
                    </>
                  );
                })()}

                <FileViewerTest
                  open={isFileViewerOpen}
                  fileUrl={fileUrl}
                  isLoading={isLoading}
                  fileName={fileName}
                  deleteTempFiles={deleteTempFiles}
                  setOpenDialog={setOpenDialog}
                  onClose={() => setFileViewerOpen(false)}
                  setFileViewerOpen={setFileViewerOpen}
                  baseURL={baseURL}
                />
              </div>
            ) : (
              <div className="no-search-results-message">No Files to View</div>
            )}


          </div>
        </div >
        )}

        {/* Close button pinned at the bottom with a divider (see ViewFiles.scss) */}
        <div className="close-button-container">
          <MotifButton onClick={onClose} variant='primary' className='close-button'>
            Close
          </MotifButton>
        </div>
        <Dialog
          open={openDialog}
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className='deleteDialogBox'
        >
          <DialogTitle>
            <IconButton
              onClick={handleDialogClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
            <img src={require("../../common/images/warning-triangle.png")} alt={"Note"} />

          </DialogTitle>
          <DialogContent>
            <span id="alert-dialog-description">
              <strong>
                {selectedControlIds.length > 1
                  ? "Are you sure you want to permanently delete the selected " + selectedControlIds.length + " files?"
                  : "Are you sure you want to permanently delete this file?"}
              </strong>
              <p>This action cannot be undone.</p>
            </span>
          </DialogContent>
          <DialogActions>
            <MotifButton onClick={handleDialogClose} color="secondary" variant='secondary' autoFocus>
              Cancel
            </MotifButton>
            <MotifButton onClick={handleDialogConfirm} color="primary" autoFocus>
              Yes
            </MotifButton>
          </DialogActions>
        </Dialog>
        {/* {showToast && (
                <MotifToast key={"toast"}className="viewFiles-toast-container" variant="error" onClose={handleCloseToast}>
                    <div >
                        {toastMessage}
                    </div>
                </MotifToast>
            )} */}
      </MotifMenu >
    </>
  );
};
